<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            EDIT BILL PAYMENT {{ (form && form.hasOwnProperty('number') && form.number) ? form.number : '' }}
            ({{
              originalHeader && originalHeader.hasOwnProperty('status') && originalHeader.status
              ? originalHeader.status
              : ''
            }})
          </h2>
        </el-row>
      </el-col>
      <DataEntryButtons
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :hasBeenChanged="hasBeenChanged"
        :disableDistChanges="disableDistChanges"
        :disableAuditBtn="disableAuditBtn"
        :disablePostBtn="disablePostBtn"
        :transactionType="transactionType"
        :numberOfFiles="numberOfFiles"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Bill Payment')"
        @postBtnClick="handlePostBtnClick('Bill Payment')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
    <el-row justify="start" align="start" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" class="left-aligned-col">
        <el-row justify="start" align="start" type="flex">
          <HeaderFields
            title="Customer"
            :openCreateModal="openCreateModal"
            :fields="fields.customer"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Bill Payment Details"
            :fields="fields.bpDetails"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Payment Info"
            :fields="fields.paymentInfo"
            :form="form"
            :lines="lines"
            :idPrefix="'d-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="bp"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="originalLines"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :clearFields="lineFieldsToClear"
        @lineModified="lineModified"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @updateLines="updateLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      :visible.sync="dialogVisible"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" @click="cancelExit">
          Cancel
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="goBack(true)">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="handleSubmit(false)">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      size="small"
      top="10%"
      :visible.sync="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  /* eslint-disable no-return-assign */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  import { isTransactionBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import { bpMixins } from '@/Mixins/BpMixins'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import store from '@/store/store'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      DataEntryButtons,
      DocumentDialog,
      LinesLoading
    },
    mixins: [ transactionMixins, transactionEditViewMixins, bpMixins ],
    data () {
      const { getBpById, getBpLinesByTransactionId, getBatchById, getCustomerById } = this.$store.getters
      const c = getBpById(this.$route.params.id)
      let lines = Object.values(getBpLinesByTransactionId(c.id)).map((line, i) => {
        return { line_number: line.line_number || i + 1, form: { ...line } }
      })
      return {
        modelId: null,
        transactionType: { name: 'bp', path: '/bps/', prettyName: 'Bill Payment' },
        originalHeader: c,
        originalLines: lines,
        form: {
          customer: { label: c.customer ? getCustomerById(c.customer).name : '', value: c.customer || '' },
          batch: { label: c.batch ? getBatchById(c.batch).name : '', value: c.batch || '' },
          number: c.number || '',
          date: c.date || '',
          description: c.description || '',
          period: c.period || '',
          amount_decimal: c.amount_decimal || '',
          payment_method: c.payment_method || 'CHK',
          payment_confirmation_number: c.payment_confirmation_number || '',
          status: c.status
        },
        lines,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(c.status),   // TODO: ask about what statuses render AR readonly
        createModals: { batch: { visible: false } },  // TODO: still needed?
        changesWereSaved: false,
        transactionIsBalanced: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        currentCustomerSelection: '',
        lineFieldsToClear: [],
        ready: false,
        disableAuditBtn: false,
        disablePostBtn: false,
        onSubmitOpts: {},
        notificationBox: undefined,
        dropzoneVisible: false
      }
    },
    methods: {
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Handles navigation when the "Back" button is hit
       */
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        if (this.altRoute) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'BPs' })
        }
      },
      /**
       * Submits the form.
       * @param saveOnly Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas Specifies deltas that need to be hard-coded/manually set, such as status
       * @param reportToRun Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.$refs['distribution-lines'].errors.length) {
          this.$notify({ title: 'Error saving distribution changes', message: 'Incomplete lines', type: 'error' })
          return
        }
        if (this.dialogVisible) this.handleDialogVisible(false)   // Close any open dialog boxes
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount && !lDeltaCount) {
          this.isSaving = true
          this.saveHeaderChangesOnly('Bp', saveOnly, reportToRun)
        } else if (!hDeltaCount && lDeltaCount) {
          this.saveLineChangesOnly('Bp', saveOnly, reportToRun)
        } else if (hDeltaCount && lDeltaCount) {
          const newBank = this.getBankByBatchId(this.headerDeltas.batch)
          const oldBank = this.getBankByBatchId(this.originalHeader.batch)
          if (newBank && newBank.currency !== oldBank.currency) {
            this.saveLineChangesOnly('Bp', saveOnly, reportToRun)
              .then(() => this.saveHeaderChangesOnly('Bp', saveOnly, reportToRun))
              .catch(e => console.log(e))
          } else {
            this.saveHeaderAndLineChanges('Bp', saveOnly, reportToRun)
          }
        } else {
          isTransactionBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates header form
       * @param form
       */
      updateForm (form) {
        this.form = Object.assign({}, form)
        isTransactionBalanced(this)
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
        if (this.form.customer.value) this.currentCustomerSelection = this.form.customer.value
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
      },
      /**
       * Checks whether any changes were made to the distribution lines
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        isTransactionBalanced(this)
        this.checkForChanges()
      },
      /**
       * Open new batch or new customer modal
       * @param type
       */
      openCreateModal (type) {
        if (type === 'customer') {
          this.$store.dispatch('changeModalVisibility', { entityType: 'customerVendorForm', visible: true, inDataEntryView: true, type: 'customer' })
        } else {
          this.createModals[type].visible = true
        }
      },
      /**
       * Close new batch or new customer modal
       * @param type
       */
      closeCreateModal (type) {
        this.createModals[type].visible = false
      },
      /**
       * Updates the status field in the header whenever the latest data for this AR hits the store,
       * then calls this.disableHeaderFields if the AR is closed, posted, or voided.
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables specific header fields
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.customer.inputFields.map(v => {
          if (v.name === 'customer') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
        })
        tmpFields.bpDetails.inputFields.map(v => {
          if (v.name === 'amount_decimal') v.disabled = true
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      /**
       * Checks whether the currency has changed, based on the value of the batch's bank. If it has,
       * checks whether or not any lines have bills that do not match the currency of the current batch,
       * and if so, warns the user that this may cause an error if attempting to save.
       */
      checkForCurrencyChange () {
        const newBank = this.getBankByBatchId(this.headerDeltas.batch)
        const oldBank = this.getBankByBatchId(this.originalHeader.batch)
        if (!newBank || (newBank && newBank.currency === oldBank.currency)) return
        this.$nextTick(() => {
          let affectedLines = this.lines.filter(line => {
            if (!(line.form && line.form.bill.value)) return false
            let bill = line.form.bill.value ? this.getArById(line.form.bill.value) : null
            let billBank
            if (bill && bill.batch) {
              billBank = this.getBankByBatchId(bill.batch)
            }
            return (billBank && billBank.currency !== newBank.currency)
          })
          if (affectedLines && affectedLines.length) {
            const h = this.$createElement
            this.$msgbox({
              title: 'Warning',
              message: h('div', null, [
                h('div', null, 'The currency for bills set in the following lines does not match that of the currently selected batch:'),
                h('div', { style: 'display: inline-block' }, [
                  h('ul', null, [
                    ...affectedLines.map(v => h('li', { style: 'padding: 6px 0;' }, `Line ${v.line_number}: bill is ${v.form.bill.label}`))
                  ])
                ]),
                h('div', null, 'Saving this bill payment in this state could result in an error. Please change the associated bills and respective prepayments, if any, prior to saving.')
              ]),
              showCancelButton: false,
              confirmButtonText: 'OK',
              customClass: 'msg-box-wide'
            })
            .catch(e => console.log(e))
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        getBps: 'getBps',
        getBpById: 'getBpById',
        getBpLineById: 'getBpLineById',
        getLineById: 'getLineById',
        getBpLinesByTransactionId: 'getBpLinesByTransactionId',
        getBpLines: 'getBpLines',
        getPeriodById: 'getPeriodById',
        getArById: 'getArById'
      }),
      selectedPeriod () {
        const bp = this.getBpById(this.$route.params.id)
        if (bp && bp.period && this.getPeriodById(bp.period).id) {
          return this.getPeriodById(bp.period)
        }
      },
      fields () {
        const c = this.getBpById(this.$route.params.id)
        let fields = {
          customer: {
            inputFields: [
              {
                name: 'customer',
                label: 'Customer',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'customers' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a customer',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              }
            ],
            displayFields: [
              {
                name: 'customer',
                label: 'Type',
                value: this.form.customer.value ? this.getCustomerById(this.form.customer.value).entity_type : ''
              },
              {
                name: 'customer',
                label: 'Work State',
                value: this.customerWorkState
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches', params: { active: true } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          bpDetails: {
            inputFields: [
              {
                name: 'number',
                label: 'Number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                msg: 'Please specify a date'
              },
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          paymentInfo: {
            inputFields: [
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                isMoney: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              },
              {
                name: 'payment_method',
                label: 'Payment type',
                dataType: 'string',
                fieldType: 'select',
                required: true,
                options: [
                  { label: 'Check', value: 'CHK' },
                  { label: 'Cash', value: 'CSH' },
                  { label: 'Automated Clearing House', value: 'ACH' }
                ],
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              },
              {
                name: 'payment_confirmation_number',
                label: 'Payment number',
                dataType: 'string',
                fieldType: 'input',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && c.payment_confirmation_number
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Balance',
                value: c.balance_decimal || ''
              },
              {
                label: 'Amount Paid',
                value: c.amount_paid_decimal || ''
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.bpDetails.inputFields[3].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.bpDetails.inputFields[3].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      }
    },
    watch: {
      /**
       * Watches the BP store for any new data returned by the API. When this transaction is updated,
       * the API will return a fresh copy, which will hit the store and trigger the following updates
       * to this component.
       */
      getBps () {
        const newHeader = this.getBpById(this.originalHeader.id)
        if (newHeader && Object.keys(newHeader).length) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status)
        }
      },
      /**
       * Watches the BP store's lines property for any new or updated distribution lines.
       * This is needed in order to render offset lines created by the API on the fly.
       */
      getBpLines () {
        const recent = () => {
          let incoming = Object.values(this.getBpLinesByTransactionId(this.$route.params.id))
          return incoming.map((line, i) => {
            const line_number = line.line_number || i + 1
            return { line_number, form: Object.assign({}, line) }
          })
        }
        if (this.ready && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = true
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        this.amountHasChanged = Object.keys(this.headerDeltas).includes('amount_decimal')
        if (this.headerDeltas.batch && this.headerDeltas.batch !== this.originalHeader.batch) {
          this.checkForCurrencyChange()
        }
      }
    },
    /**
     * Things that should be done when the component is created
     */
    created () {
      this.lines = sortLines(this.lines)
      isTransactionBalanced(this)
      this.updateForm(this.form)
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getCurrentPeriod } = store.getters
      const periodExists = getCurrentPeriod && Object.keys(getCurrentPeriod).length
      try {
        const resp = await store.dispatch('fetchBpsWithQuery', { query: { id: to.params.id }, storeLines: true })
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities)
          promises = [...promises, ...deps]
        }
        await Promise.all(promises)
        if (!periodExists) {
          await store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    }
  }
</script>

<style>
  .msg-box-wide {
    width: 585px;
  }
</style>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Bps/Edit.vue